export const bannerText = import.meta.env.VITE_APP_BANNER_TEXT
